module.exports = __webpack_public_path__ + "img/nomessage.d8d1d8de.png";